import { LuInfo } from 'react-icons/lu';

import { cn } from '~/utils/cnTailwind';

type Props = {
    title: string;
    messages: { text?: string }[];
    type: 'warning' | 'error';
};

export const Notices: React.FC<Props> = ({ messages, title, type }) => (
    <div className="flex flex-col gap-2 rounded-md border border-grey-outline-light p-4">
        <p className="flex items-center gap-2 text-sm font-bold text-midnight">
            <LuInfo className={cn('size-4', type === 'warning' ? 'text-orange-tag' : 'text-blue')} />
            {title}
        </p>
        <ul className="flex flex-col gap-1 text-sm text-midnight">
            {messages.map((message) => (
                <li key={message?.text} className="before:content-['–_']">
                    {message?.text}
                </li>
            ))}
        </ul>
    </div>
);
